import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@/components/ui/Icon';
import { StarRating } from '@/components/ui/StarRating';
import { Button } from '@/components/ui/Button';
import { Colors } from '@/constants/Colors';
import { useTheme } from '@/hooks/useTheme';

export default function NewObservationPage() {
  const navigate = useNavigate();
  const colors = useTheme();
  const [playerName, setPlayerName] = useState('');
  const [selectedTeam, setSelectedTeam] = useState<'home' | 'away'>('home');
  const [rating, setRating] = useState(3);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, backgroundColor: colors.background }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 16, borderBottom: `1px solid ${Colors.primary}15` }}>
        <button onClick={() => navigate(-1)} style={{ width: 40, height: 40, borderRadius: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: `${Colors.primary}15`, cursor: 'pointer' }}>
          <Icon name="chevron-back" size={24} color={Colors.primary} />
        </button>
        <span style={{ fontSize: 18, fontWeight: 700, color: colors.text }}>New Observation</span>
        <div style={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Icon name="analytics" size={24} color={Colors.primary} />
        </div>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: 16, paddingBottom: 100 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 24, fontWeight: 700, marginBottom: 8, color: colors.text }}>Scout a Talent</div>
          <div style={{ fontSize: 14, color: colors.textSecondary }}>Amateur football scouting - Ile-de-France</div>
        </div>

        <div style={{ marginBottom: 24 }}>
          <div style={styles.sectionLabel}>PLAYER DETAILS</div>
          <div style={{ display: 'flex', alignItems: 'center', height: 56, borderRadius: 16, paddingLeft: 16, paddingRight: 16, backgroundColor: colors.surface, gap: 12 }}>
            <Icon name="person-outline" size={20} color={colors.textSecondary} />
            <input
              style={{ flex: 1, fontSize: 16, border: 'none', outline: 'none', background: 'transparent', color: colors.text }}
              value={playerName} onChange={(e) => setPlayerName(e.target.value)}
              placeholder="Player Name or Number (e.g. #10)"
            />
          </div>
        </div>

        <div style={{ marginBottom: 24 }}>
          <div style={styles.sectionLabel}>SELECT TEAM</div>
          <div style={{ display: 'flex', gap: 12 }}>
            {(['home', 'away'] as const).map((t) => (
              <button key={t} onClick={() => setSelectedTeam(t)} style={{
                flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingTop: 16, paddingBottom: 16, borderRadius: 16,
                border: selectedTeam === t ? `2px solid ${Colors.primary}` : '2px solid transparent', gap: 4, cursor: 'pointer',
                backgroundColor: selectedTeam === t ? `${Colors.primary}08` : colors.surface,
              }}>
                <Icon name={t === 'home' ? 'home' : 'airplane'} size={28} color={selectedTeam === t ? Colors.primary : colors.textSecondary} />
                <span style={{ fontSize: 14, fontWeight: 700, color: selectedTeam === t ? Colors.primary : colors.textSecondary }}>
                  {t === 'home' ? 'Home' : 'Away'}
                </span>
              </button>
            ))}
          </div>
        </div>

        <div style={{ marginBottom: 24 }}>
          <div style={{ ...styles.sectionLabel, textAlign: 'center' }}>PERFORMANCE RATING</div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: 24, paddingBottom: 24, borderRadius: 16, backgroundColor: colors.surface }}>
            <StarRating rating={rating} onRatingChange={setRating} size={40} />
          </div>
          <div style={{ fontSize: 12, fontStyle: 'italic', textAlign: 'center', marginTop: 12, color: colors.textSecondary }}>"Great presence, solid defense"</div>
        </div>

        <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
          <Button title="Add More Details" onPress={() => navigate('/observation/detailed')} icon={<Icon name="chevron-forward" size={20} color="#ffffff" />} size="large" />
          <Button title="Submit Quick Observation" onPress={() => navigate(-1)} variant="secondary" icon={<Icon name="send" size={20} color={Colors.primary} />} />
        </div>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  sectionLabel: { fontSize: 12, fontWeight: 600, color: `${Colors.primary}cc`, letterSpacing: 1, marginBottom: 12, paddingLeft: 4, paddingRight: 4 },
};
